module.exports = __webpack_public_path__ + "img/dislike-red.3fa9bd14.svg";